module.exports = __webpack_public_path__ + "static/media/Adobe_Illustrator_CC_icon 10.afc5bb5d.png";